/**
 * Layout: Tekst intro
 * Slug: text_intro
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.text_intro-layout');

	layouts.forEach((layout) => {
		
	});
});
